const STEALTH_INTELLIGENCE_ENABLED_ORGS = new Set([
  // Ergode (68c1277ed788e6f3657b6f41) — reverted to NORMAL TG pages — 2026-07-02.
  // S5 (68b2c559f43d78cbf207113b) — reverted to NORMAL TG pages; stealth surfaces
  //   via gap-fill in the normal dashboard/summaries instead of a separate page — 2026-06-30.
  // Market Research Future (6a158e92ecba51bec473b1c8 / musaib.shaikh@marketresearchfuture.com)
  //   reverted to NORMAL TG pages like other orgs — 2026-06-30.
]);

const STEALTH_UNDER_CRM_ORGS = new Set([
  // S5 (68b2c559f43d78cbf207113b) — stealth "Stealth Intelligence" sidebar group removed;
  //   normal TG Intelligence kept, stealth shows via gap-fill — 2026-06-30.
]);

function normalizeOrgId(org) {
  if (!org) return null;
  if (typeof org === 'string') return org;
  if (typeof org === 'object') return org._id || org.id || null;
  return null;
}

export function isStealthIntelligenceEnabledForOrg(org) {
  const orgId = normalizeOrgId(org);
  if (!orgId) return false;
  return STEALTH_INTELLIGENCE_ENABLED_ORGS.has(String(orgId));
}

export function canUserAccessStealthIntelligence(user) {
  if (!user) return false;
  if (user.role === 'main_admin' || user.isMainAdminSwitch) return true;
  return isStealthIntelligenceEnabledForOrg(user.organizationId);
}

export function isStealthUnderCrmOrg(org) {
  const orgId = normalizeOrgId(org);
  if (!orgId) return false;
  return STEALTH_UNDER_CRM_ORGS.has(String(orgId));
}

export { STEALTH_INTELLIGENCE_ENABLED_ORGS, STEALTH_UNDER_CRM_ORGS };
